"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const WikiLinks_1 = require("@/client/utils/WikiLinks");
const officialExpansions = [
    { module: 'corpera', name: 'Corporate Era', iconClass: 'CE', url: WikiLinks_1.RULEBOOK_URLS.corpera },
    { module: 'venus', name: 'Venus Next', iconClass: 'venus', url: WikiLinks_1.RULEBOOK_URLS.venus },
    { module: 'prelude', name: 'Prelude', iconClass: 'prelude', url: WikiLinks_1.RULEBOOK_URLS.prelude },
    { module: 'prelude2', name: 'Prelude 2', iconClass: 'prelude2', url: WikiLinks_1.RULEBOOK_URLS.prelude2 },
    { module: 'colonies', name: 'Colonies', iconClass: 'colony', url: WikiLinks_1.RULEBOOK_URLS.colonies },
    { module: 'turmoil', name: 'Turmoil', iconClass: 'turmoil', url: WikiLinks_1.RULEBOOK_URLS.turmoil },
];
const fanExpansions = [
    { module: 'promo', name: 'Promos', iconClass: 'promo', url: WikiLinks_1.RULEBOOK_URLS.promo },
    { module: 'ares', name: 'Ares', iconClass: 'ares', url: WikiLinks_1.RULEBOOK_URLS.ares },
    { module: 'community', name: 'Community', iconClass: 'community', url: WikiLinks_1.RULEBOOK_URLS.community },
    { module: 'moon', name: 'The Moon', iconClass: 'themoon', url: WikiLinks_1.RULEBOOK_URLS.moon },
    { module: 'pathfinders', name: 'Pathfinders', iconClass: 'pathfinders', url: WikiLinks_1.RULEBOOK_URLS.pathfinders },
    { module: 'ceo', name: 'CEOs', iconClass: 'ceo', url: WikiLinks_1.RULEBOOK_URLS.ceo },
    { module: 'starwars', name: 'Star Wars', iconClass: 'starwars', url: WikiLinks_1.RULEBOOK_URLS.starwars },
    { module: 'underworld', name: 'Underworld', iconClass: 'underworld', url: WikiLinks_1.RULEBOOK_URLS.underworld },
];
exports.default = (0, vue_1.defineComponent)({
    name: 'HelpRulebooks',
    data() {
        return {
            officialExpansions,
            fanExpansions,
        };
    },
});
